<!-- New: with DocuSign sidebar integration -->
<ng-container *ngIf="hasPoaDocusignFlag; else oldDocumentUpload">
  <document-upload-desktop
    [attachmentName]="attachmentName"
    [attachmentTypeName]="attachmentTypeName"
    [attachmentHint]="attachmentHint"
    [id]="
      document.rootEntityType +
      '-' +
      document.rootEntityId +
      '-' +
      document.relatedEntityType +
      '-' +
      document.relatedEntityId +
      '-' +
      document.type +
      (document.id ? '-' + document.id : '')
    "
    [isSidebarManagedMode]="hasPoaDocusignFlag"
    [canUploadDocuments]="!hasPoaDocusignFlag && isCanUploadDocuments"
    [canRemoveDocuments]="isCanRemoveDocuments"
    [uploadedDocument]="document"
    [isRequired]="isRequiredDocument"
    [isLoading]="isLoading"
    [isStripeLayout]="true"
    [isStretched]="true"
    [isHidePoaDownload]="true"
    [isCustomBrowseBtn]="true"
    [footerHint]="managePoaFooterHint"
    [footerHintAction]="footerHintAction"
    (upload)="openPoaModal($event)"
    (remove)="onRemoveFile($event)"
    (stateUpdate)="onStateUpdate($event)"
  >
    <button type="button" class="btn btn-outline-secondary btn-square btn-sm" custom-browse-btn (click)="onManagePoaClick()">
      {{ "COMPANY.DIGITAL-SIGNATURE.BUTTON" | translate }}
    </button>
  </document-upload-desktop>
</ng-container>

<!-- Old: without DocuSign sidebar integration -->
<ng-template #oldDocumentUpload>
  <document-upload-desktop
    [attachmentName]="attachmentName"
    [attachmentTypeName]="attachmentTypeName"
    [attachmentHint]="attachmentHint"
    [id]="
      document.rootEntityType +
      '-' +
      document.rootEntityId +
      '-' +
      document.relatedEntityType +
      '-' +
      document.relatedEntityId +
      '-' +
      document.type +
      (document.id ? '-' + document.id : '')
    "
    [canUploadDocuments]="isCanUploadDocuments"
    [canRemoveDocuments]="isCanRemoveDocuments"
    [uploadedDocument]="document"
    [isRequired]="isRequiredDocument"
    [isLoading]="isLoading"
    [isStripeLayout]="true"
    [isStretched]="true"
    (upload)="openPoaModal($event)"
    (remove)="onRemoveFile($event)"
    (stateUpdate)="onStateUpdate($event)"
  ></document-upload-desktop>
</ng-template>
